import type { FaireProductEntity } from "../../entity_types/product";

export const p_c798tvxsbd: FaireProductEntity = {
  token: "p_c798tvxsbd",
  type: "product",
  name: "Nutcracker Mini PRO Holiday Ornament Giftable",
  brandToken: "b_51514ef0",
  brandName: "The Original MakeUp Eraser",
  imageUrl:
    "https://cdn.faire.com/fastly/77d4217e77127c9051db96634c3b35a421dba270e766cb3857261261402cb92f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a6892df62f1d1bc55b1f0427fcb8faa9cc1e61fd4bc0415e30e9d5d12e5d39e.jpeg",
    "https://cdn.faire.com/fastly/c0c95a03420325c893747bc5b0e105b90c784d05ace615b262afce91f0851b2a.png",
    "https://cdn.faire.com/fastly/3372661510b3190519f4cbdb23544d040eaf58d8a9cacb26a237a26fcba05ed7.png",
    "https://cdn.faire.com/fastly/52d2e73669e5e7760f1805e6d431f58fb19bb00a4a14b581b6ab5bcebeeb92e3.jpeg",
    "https://cdn.faire.com/fastly/84ed64fbdc8d5f9e2c5c00d12105641d08ec00147e107f42af6bf693f0662217.png",
  ],
  priceDollars: 6,
  description:
    "Includes 1 Mini PRO MakeUp Eraser, 8in x 4in.\n\nErase all makeup with JUST WATER™ including waterproof. Our patented, water-activated, cloud-soft fibers gently & easily remove all makeup & sunscreen from pores. 2 in 1 benefit: one side erases makeup & one side exfoliates skin.\n\n\n\n\n✓ Dermatologist Recommended\n\n\n✓ SmartErase™ Technology\n\n\n✓ Reusable & machine washable\n\n✓ Great for heavy makeup\n\n\n\n\nThe Original MakeUp Eraser® is non-irritating and non-drying, making it perfect for sensitive skin. It's non-comedogenic, safe for lash extensions, & entirely oil-free for a fresh, comfortable experience.\n\n\n",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:16.158Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
